import { useContext, useEffect, useState } from 'react'
import useDebouncedValue from '../../../../utils/common_function'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import SelectInput from '../../../common/SelectInput'
import { getRequest, postRequest } from '../../../../services/base'
import Button from '../../../common/Button'
import { NavContext } from '../../../../context/global_context'

const PlantVehicles = ({ setShowModal, showModal, selectedPlant }) => {
  const [state, dispatch] = useContext(NavContext)

  const [selectedVehicles, setSelectedVehicles] = useState([])
  const [vehiclesList, setVehiclesList] = useState([])
  const [searchVehicles, setSearchVehicles] = useState('')
  const debouncedToSearchVehicles = useDebouncedValue(searchVehicles, 1000)

  const getVehiclesList = async (search = '') => {
    let res = await getRequest(`/api/vehicles/?search=${search}`)
    setVehiclesList(res?.results)
  }

  useEffect(() => {
    getVehiclesList(searchVehicles)
  }, [debouncedToSearchVehicles])

  useEffect(() => {
    if (selectedPlant?.id) {
      getSelectedVehicles(selectedPlant?.id)
    }
  }, [selectedPlant])

  const getSelectedVehicles = async (plantId) => {
    let res = await getRequest(`/api/plants/vehicles/${plantId}/`)
    setSelectedVehicles(res.data)
  }

  const savePlatVehicles = async () => {
    let res = await postRequest(
      `/api/plants/save_vehicles/${selectedPlant?.id}/`,
      {
        vehicles: selectedVehicles,
      }
    )
    if (res?.status) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Selected Make Models Added in Plant`,
        },
      })
      closePlantMakeModelModal()
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    }
  }

  const closePlantMakeModelModal = () => {
    setShowModal(false)
    setSelectedVehicles([])
    setSearchVehicles('')
  }

  return (
    <Modal
      onClose={() => {
        closePlantMakeModelModal()
      }}
      show={showModal}
    >
      <ModalHeader className={'text-white'}>
        Add Or Remove Plant Make Models
      </ModalHeader>
      <ModalBody>
        <div style={{ height: '20vh' }}>
          <SelectInput
            options={vehiclesList}
            label={`Select Make`}
            optionLabel="name"
            optionValue="id"
            placeholder={`Select Make`}
            onInputChange={(value) => {
              setSearchVehicles(value)
            }}
            isMulti={true}
            name="make_models"
            onChange={(value) => {
              setSelectedVehicles(value)
            }}
            value={selectedVehicles}
          />
        </div>

        <div className="flex justify-end">
          <Button
            type="submit"
            className={`cursor-pointer btn my-4 px-2 w-4/12 justify-end`}
            onClick={(e) => {
              savePlatVehicles()
            }}
            value={'text'}
            text={`Save Plant Make Models`}
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default PlantVehicles
